// extracted by mini-css-extract-plugin
export var card = "ListCard-module--card--OX2ad";
export var cardContent = "ListCard-module--card-content--CjRPL";
export var root = "ListCard-module--root--znEi1";